import React from 'react';
import { useIntl } from '../../util/reactIntl';
import classNames from 'classnames';
import {
  ensureUser,
  ensureCurrentUser,
  userDisplayNameAsString,
  userAbbreviatedName,
} from '../../util/data';
import { PROFILE_PAGE_PENDING_APPROVAL_VARIANT } from '../../util/urlHelpers';
import { isUserAuthorized } from '../../util/userHelpers';

import { ResponsiveImage, IconBannedUser, NamedLink } from '../../components/';

import IcoBadge from '../../assets/censo/check_v1.svg';
import IcoBadgeNot from '../../assets/censo/checknot_v1.svg';

import css from './Badge.module.css';
export const Badge = props => {
  
  const { isCensusCompleted, linkTo } = props;

  const intl = useIntl();
  //const userEntity = ensureUser(user);
  //const currentUserEntity = ensureCurrentUser(currentUser);
  
  //console.log("isCensusCompleted", isCensusCompleted);

  const BadgeContent = ({ completed }) => (
    <>
      <div className={css.icon}>
        <img src={completed ? IcoBadge : IcoBadgeNot} alt={completed ? "Censado" : "No censado"} />
      </div>
      <div className={css.text}>
        {completed ? 'Rodantero Censado' : 'Rodantero No Censado'}
      </div>
    </>
  );

  return (
    <>
      {isCensusCompleted ? (
        <NamedLink
          name={linkTo}
          className={classNames(css.badge, css.badgeLink)}
        >
          <BadgeContent completed={true} />
        </NamedLink>
      ) : (
        <NamedLink
          name={linkTo}
          className={classNames(css.badgeNot, css.badgeLink)}
        >
          <BadgeContent completed={false} />
        </NamedLink>
      )}
    </>
  )
    
  
};

export default Badge;